import { put, takeLatest } from "redux-saga/effects";

import { GET_ZOOM_CHAT_HISTORY } from "../constants/ActionTypes";
import { IGetChatHistoryArgs } from "../types/chat.types";

function* getChatHistory({ payload }: IGetChatHistoryArgs) {
  try {
    const { chatClient } = payload;
    const chatHistory = chatClient.getHistory();
    yield put({
      type: `${GET_ZOOM_CHAT_HISTORY}_SUCCESS`,
      payload: chatHistory,
    });
  } catch (error) {
    yield put({
      type: `${GET_ZOOM_CHAT_HISTORY}_FAILURE`,
      payload: {},
    });
  }
}

export default function* loadChatSaga() {
  yield takeLatest(GET_ZOOM_CHAT_HISTORY, getChatHistory);
}
